<div mat-dialog-title class="dialog-info">
    <label class="dialogTitle">
        {{'SAVE_MULTI_PDF_GROUP' | translate}}
    </label>
    <button type="button" class="btn-close btn-close-white shadow-none crossButtonPosition" [mat-dialog-close]></button>
</div>

<div class="row container-fluid pr-0" [formGroup]="multiPdfSaveForm">
    <div class="col-md-12 pr-0">
        <mat-dialog-content class="contentPadding">
            <div class="form-row">
                <mat-label class="form-label bold">
                    {{ 'SELECTION' | translate }}:
                </mat-label>
                <mat-form-field appearance="outline" class="form-field-full">
                    <input matInput type="text"
                           class="form-input" formControlName="selectionName">
                </mat-form-field>
            </div>
            
            <div class="form-row">
                <mat-label class="form-label bold">
                    {{ 'DESCRIPTION' | translate }}:
                </mat-label>
                <mat-form-field appearance="outline" class="form-field-full">
                    <input matInput type="text"
                           class="form-input" formControlName="description">
                </mat-form-field>
            </div>
        </mat-dialog-content>

        <mat-dialog-actions align="end" class="actionsPadding">
            <div>
                <button class="openCloseBtn" mat-raised-button color="primary" 
                        (click)="onSave()" [disabled]="!multiPdfSaveForm.valid">
                    {{'SAVE' | translate}}
                </button>
                <button class="openCloseBtn" mat-raised-button color="warn" [mat-dialog-close]>
                    {{'COMMON_DIALOGS_BTN_LABELS_CANCEL' | translate}}
                </button>
            </div>
        </mat-dialog-actions>
    </div>
</div>
